import { Component, OnInit, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { IConversation } from '../../../models/iconversation';
import { CommunicationService } from '../../../services/shared/communication/communication.service';
import { MessageService } from '../../../services/shared/message/message.service';
import { IChatHistory, IConversationHistory } from 'src/app/models/chat-history';
import { TokenService } from 'src/app/services/core/token/token.service';
import { MatDialog } from '@angular/material';
import { HandoffCommentComponent } from '../../shared/handoff-comment/handoff-comment.component';
import { NotificationService } from '../../../services/shared/notification/notification.service';
import { ToasterService } from '../../../services/shared/toaster/toaster.service';
import { WarningPopupComponent } from '../../shared/warning-popup/warning-popup.component';
import { BotHistoryComponent } from '../../shared/bot-history/bot-history.component';
import { ConnectedStatusService } from 'src/app/services/shared/connection-status/connected-status.service';
import { AddNewAgentComponent } from '../add-new-agent/add-new-agent.component';
import { IHandOffComments } from 'src/app/models/handoff-comment';
import { IHilRequest } from 'src/app/models/hilrequest';
import { GroupChatParticipantsComponent } from '../group-chat-participants/group-chat-participants.component';
import { GroupChatActiveAgents } from 'src/app/models/group-chat-active-agents';
import { ITypingStatus } from '../../../models/itypingstatus';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-hilconversations',
  templateUrl: './hilconversations.component.html',
  styleUrls: ['./hilconversations.component.scss']
})
export class HilconversationsComponent implements OnInit {

  private _hubConnection: HubConnection;
  agentLoginId = '';
  loggedInAgentFullName = '';
  activeBotUserName = '';
  activeBotUserId = '';
  activeBotName = '';
  activeBotConfigId: number;
  activeBotId: string = '';
  activeBotHandOffComment: IHandOffComments[] = [];
  BotHandOffInfo: IHandOffComments[] = [];
  handOffDetails: IHandOffComments;
  activeChatbotHistory: IChatHistory[] = [];
  conversationHistory: IConversationHistory[] = [];
  agentNickName = '';
  hilRequest = false;
  connectedStatus = false;
  message = '';
  mm = {} as IConversation;
  conversations = [] as Array<IConversation>;
  activeConversations = [] as Array<IConversation>;
  activeConversationsByChatID = [] as Array<IConversation>;
  activeConversationId = '';
  activePrimaryAgent = true;
  activeChatIsGroupChat = false;
  activeGroupChatAgents: GroupChatActiveAgents = new GroupChatActiveAgents();
  messages = [];
  connectedBots = [];
  duplicateChat: any;
  agentName: string;
  scrollerHt: any;
  showBotUserDetailsTootTip: boolean = false;
  tooltipDisplay: any;
  activeTypings = [] as Array<ITypingStatus>;
  activeTypingsByActiveConversationId = [] as Array<ITypingStatus>;
  activeTypingNotificationMessage: string;
  currentTypingStatus: boolean;
  isCCenterWindowFocused = true;
  notifyTypingStatusOffSourceSendButton = false;
  botUserReconnectionStatus: string = '';
  isAttached = false;
  click = true;
  imageURL = '';
  isImage = '';
  hrefLink = '';
  specialcharacter = false;
  htmlElements = false;
  messageboxvalid: boolean = true;
  IsValidChatManagerRole = false;
  FirstMessage: boolean;
  hasAssociatedBot: boolean = false;
  associatedBotId: number;
  associatedBotName: string = '';
  isAssociatedBotAgent: boolean = false;


  constructor(private service: CommunicationService,
    private toasterService: ToasterService,
    private notificationService: NotificationService,
    private messageService: MessageService,
    private tokenService: TokenService,
    private dialogComment: MatDialog,
    private dialogChatHistory: MatDialog,
    private dialogWarning: MatDialog,
    private changeDetector: ChangeDetectorRef,
    private connectedStatusService: ConnectedStatusService,
    private sanitizer: DomSanitizer) {

    window.addEventListener('blur', event => {
      this.isCCenterWindowFocused = false;
      this.notifyTypingStatusOff(null);
    });
    window.addEventListener('focus', event => {
      this.isCCenterWindowFocused = true;
    });
  }
  ngAfterViewInit() {
    this.onNavigationFromNotifications();//set connected Bot based on notification selection
  }
  ngAfterViewChecked() {
    this.changeDetector.detectChanges();//refresh the chat window after row selection from notification
  }
  ngOnInit() {
    this.initialiseConversationTab();
  }
  initialiseConversationTab() {
    this._hubConnection = this.service.GetHubConnection();
    this.agentLoginId = localStorage.getItem('userEmailId');
    this.loggedInAgentFullName = localStorage.getItem('userFullName');
    this.clearAllNotifications();
    var conBots = localStorage.getItem("connectedBots");
    if (conBots != null) {
      this.connectedBots = JSON.parse(conBots);
    }

    var conv = localStorage.getItem("conversations");
    if (conv != null) {
      this.conversations = JSON.parse(conv);
    }

    if (this._hubConnection) {
      //on HIL request handler
      let onHilRequestHandler = (botUserName: string, chatId: string, botConfigId: number, hilRequest: IHilRequest) => {
        this.BotHandOffInfo = [];
        this.handOffDetails = {
          handOffBy: 'Bot User ' + botUserName,
          handOffTo: 'Agent ' + this.agentLoginId,
          handOffComment: hilRequest.handOffComment,
          handOffTime: hilRequest.handOffTime
        };
        this.BotHandOffInfo.push(this.handOffDetails);
        let agents = [];
        agents.push(this.loggedInAgentFullName);
        const chatInfo =
        {
          ChatId: chatId,
          BotUserName: botUserName,
          BotName: hilRequest.botName,
          HandOffComment: hilRequest.handOffComment,
          ChatHistory: hilRequest.chatHistory,
          BotUserId: hilRequest.botUserId,
          BotConfigId: botConfigId,
          HandOffTime: hilRequest.handOffTime,
          HandOffInfo: this.BotHandOffInfo,
          IsGroupChat: false,
          IsPrimaryAgent: true,
          GroupChatAgents: hilRequest.groupChatAgents,
          BotId: hilRequest.botId,
          IsChatManagerRole: hilRequest.isChatManagerRole,
          HasAssociatedBot: hilRequest.hasAssociatedBot,
          AssociatedBotConfigId: hilRequest.associatedBotConfigId,
          AssociatedBotName: hilRequest.associatedBotName
        }
        this.IsValidChatManagerRole = hilRequest.isChatManagerRole;
        this.associatedBotId = hilRequest.associatedBotConfigId;

        this.duplicateChat = this.connectedBots.find(x => x.BotUserName == botUserName && x.BotName == hilRequest.botName);

        if (this.duplicateChat) {
          //this.connectedBots.slice(this.connectedBots.indexOf(this.duplicateChat)); // slice is used to select an element from array and not remove
          this.connectedBots.splice(this.connectedBots.indexOf(this.duplicateChat), 1);
          //this.connectedBots.splice(this.duplicateChat,this.connectedBots.indexOf(this.duplicateChat))
          //if (!this.connectedBots.find(x => x.botName == chatInfo.BotName && x.botUserName == chatInfo.BotUserName))
          this.connectedBots.push(chatInfo);
        }
        else {
          this.connectedBots.push(chatInfo);
        }
        let activity: IConversation =
        {
          Type: "ConnectionState",
          ChatId: "",
          Message: botUserName + " connected",
          DateTime: new Date(),
          Sender: botUserName,
          BotId: hilRequest.botId,
          HasAttachment: false,
          IsImage: '',
          IsAssociatedBotAgent: this.isAssociatedBotAgent,
          AssociatedBotConfigId: this.associatedBotId
        }
        this.sendNotification(activity);

        localStorage.setItem("connectedBots", JSON.stringify(this.connectedBots));
        this.toasterService.info(botUserName + " Connected");
      };

      this._hubConnection.off("OnHilRequest");
      this._hubConnection.on("OnHilRequest", onHilRequestHandler);

      //on New Agent Request Handler
      let onAgentEscalationHandler = (hilRequest: IHilRequest, chatId: string, agentFullName: string, oldAgentFullName: string) => {
        const chatInfo =
        {
          ChatId: chatId,
          BotUserName: hilRequest.botUserName,
          BotName: hilRequest.botName,
          HandOffComment: hilRequest.handOffComment,
          ChatHistory: hilRequest.chatHistory,
          BotUserId: hilRequest.botUserId,
          BotConfigId: hilRequest.botConfigId,
          BotId: hilRequest.botId,
          AddedByAgentId: hilRequest.addedByAgentId,
          NewAgentId: hilRequest.newAgentId,
          HandOffTime: hilRequest.handOffTime,
          HandOffInfo: hilRequest.handOffInfo,
          IsGroupChat: hilRequest.isGroupChat,
          IsPrimaryAgent: hilRequest.isPrimaryAgent,
          GroupChatAgents: hilRequest.groupChatAgents,
          IsChatManagerRole: hilRequest.isChatManagerRole,
          IsAssociatedBotAgent: hilRequest.isAssociatedBotAgent,
          AssociatedBotConfigId: hilRequest.associatedBotConfigId
        }
        this.IsValidChatManagerRole = hilRequest.isChatManagerRole;
        this.duplicateChat = this.connectedBots.find(x => x.BotUserName == hilRequest.botUserName && x.botName == hilRequest.botName);
        this.isAssociatedBotAgent = hilRequest.isAssociatedBotAgent;
        this.associatedBotId = hilRequest.associatedBotConfigId;

        if (this.duplicateChat) {
          //this.connectedBots.slice(this.connectedBots.indexOf(this.duplicateChat)); // slice is used to select an element from array and not remove
          this.connectedBots.splice(this.connectedBots.indexOf(this.duplicateChat), 1);
          //this.connectedBots.splice(this.duplicateChat,this.connectedBots.indexOf(this.duplicateChat))
          //if (!this.connectedBots.find(x => x.botName == chatInfo.BotName && x.botUserName == chatInfo.BotUserName))
          this.connectedBots.push(chatInfo);
        }
        else {
          this.connectedBots.push(chatInfo);
        }
        let activity: IConversation =
        {
          Type: "ConnectionState",
          ChatId: chatId,
          Message: hilRequest.botUserName + " connected",
          DateTime: new Date(),
          Sender: hilRequest.botUserName,
          BotId: hilRequest.botId,
          HasAttachment: false,
          IsImage: '',
          IsAssociatedBotAgent: this.isAssociatedBotAgent,
          AssociatedBotConfigId: this.associatedBotId
        }
        this.sendNotification(activity);

        localStorage.setItem("connectedBots", JSON.stringify(this.connectedBots));

        if (hilRequest.isGroupChat) {
          this.toasterService.info("Agent: " + oldAgentFullName + " added you to group chat with Bot user: " + hilRequest.botUserName);
          this.addNotificationToActiveConversations("Agent: " + oldAgentFullName + " added agent: " + this.loggedInAgentFullName + " to chat", chatId, 'add');

        } else
          this.toasterService.info(hilRequest.botUserName + " transferred by Agent: " + oldAgentFullName);
      };

      this._hubConnection.off("onAgentEscalation");
      this._hubConnection.on("onAgentEscalation", onAgentEscalationHandler);

      //On New Agent Error handler
      let onAgentEscalationErrorHandler = (error: string) => {
        this.toasterService.error("Error: " + error);
      };

      this._hubConnection.off("onAgentEscalationError");
      this._hubConnection.on("onAgentEscalationError", onAgentEscalationErrorHandler);


      //on receive message handler
      let onReceiveMessageHandler = (chat) => {
        let array = ['jpg', 'png', 'gif', 'jpeg'];

        for (let i = 0; i < array.length; i++) {
          if (chat.message.toLowerCase().includes(array[i])) {
            this.isImage = 'yes';
            break;
          } else {
            this.isImage = 'no';
          }
        }
        const activity: IConversation = {
          ChatId: chat.chatId,
          Message: chat.message,
          Type: 'receive',
          DateTime: new Date(),
          Sender: chat.sender,
          BotId: chat.botId,
          HasAttachment: chat.type == 'file' ? true : false,
          IsImage: this.isImage,
          IsAssociatedBotAgent: this.isAssociatedBotAgent,
          AssociatedBotConfigId: this.associatedBotId
        };

        this.click = true;
        //apply css on new message arrival
        if (this.connectedBots.length > 1 && this.activeConversationId !== chat.chatId && document.getElementById(chat.chatId)) {
          this.applyBadgeOnConnectedBot(document.getElementById(chat.chatId).classList, 'new-chat-notification');
        }

        this.conversations.push(activity);

        this.activeConversations = this.conversations.filter(x => x.ChatId == this.activeConversationId);
        localStorage.setItem("conversations", JSON.stringify(this.conversations));
        this.scrollToBottom();
        this.sendNotification(activity);
      };

      this._hubConnection.off("ReceiveMessage");
      this._hubConnection.on("ReceiveMessage", onReceiveMessageHandler);


      //on Bot Disconnected handler
      let onBotDisconnectedHandler = (botName: string, chatId: string, state: string) => {
        this.botUserReconnectionStatus = '';
        if (state == "Reconnected") {
          //clearTimeout(this.timeoutState);
          this.botUserReconnectionStatus = botName + " Reconnected";
          this.toasterService.success(botName + " Re-connected");
        }
        else {
          this.toasterService.error(botName + " Disconnected");
          setTimeout(() => {
            if (this.botUserReconnectionStatus != botName + " Reconnected") {
              if (this.activeConversationId == chatId) {
                this.activeConversations = [];
                const endChat = this.connectedBots.find(x => x.ChatId == chatId);
                if (endChat != null) {
                  this.connectedBots.splice(this.connectedBots.indexOf(endChat), 1);
                  this.hilRequest = false;
                }
              }
              else {
                //remove the conversations for disconnected user which is other than active conversation user
                this.activeConversationsByChatID = this.conversations.filter(x => x.ChatId == chatId);
                if (this.activeConversationsByChatID) {
                  this.conversations = this.conversations.filter(activity =>
                    !this.activeConversationsByChatID.includes(activity)
                  );
                  localStorage.setItem("conversations", JSON.stringify(this.conversations));
                  localStorage.setItem(chatId, "true");
                  this.scrollToBottom();
                }

                //remove the connected bot entry for disconnected user
                const endChat = this.connectedBots.find(x => x.ChatId == chatId);
                if (endChat != null) {
                  this.connectedBots.splice(this.connectedBots.indexOf(endChat), 1);
                  this.hilRequest = false;
                }
              }
              localStorage.setItem("connectedBots", JSON.stringify(this.connectedBots));
              localStorage.removeItem(chatId);
              this.CloseObsoleteMapping(chatId);
            }
          }, 30000);
        }
      };

      this._hubConnection.off("onBotDisconnected");
      this._hubConnection.on("onBotDisconnected", onBotDisconnectedHandler);

      //on Agent Transferred handler
      let onAgentTransferredHandler = (botUserName, chatId, oldAgentId, newAgentName) => {
        if (this.activeConversationId == chatId) {
          this.activeConversations = [];
          const endChat = this.connectedBots.find(x => x.ChatId == chatId);
          if (endChat != null && oldAgentId == this.agentLoginId) {
            this.connectedBots.splice(this.connectedBots.indexOf(endChat), 1);
            this.hilRequest = false;
            this.toasterService.warn(botUserName + " transferred to Agent: " + newAgentName);
          }
          this.activeConversationsByChatID = this.conversations.filter(x => x.ChatId == chatId);
          if (this.activeConversationsByChatID && oldAgentId == this.agentLoginId) {
            this.conversations = this.conversations.filter(activity =>
              !this.activeConversationsByChatID.includes(activity)
            );
            localStorage.setItem("conversations", JSON.stringify(this.conversations));
            this.scrollToBottom();
          }
        }

        localStorage.setItem("connectedBots", JSON.stringify(this.connectedBots))
      };

      this._hubConnection.off("onAgentTransferred");
      this._hubConnection.on("onAgentTransferred", onAgentTransferredHandler);

      //on Agent Added to Group chat handler
      let onAgentAddedHandler = (chatId, newAgentFullName: string, oldAgentFullName: string, activeGroupChatAgents: GroupChatActiveAgents) => {
        this.connectedBots = JSON.parse(localStorage.getItem("connectedBots"))
        const groupChat = this.connectedBots.find(x => x.ChatId == chatId);
        if (groupChat != null) {
          this.connectedBots.splice(this.connectedBots.indexOf(groupChat), 1);
          groupChat.IsGroupChat = true;
          this.activeChatIsGroupChat = true;
          groupChat.GroupChatAgents = activeGroupChatAgents;
          this.activeGroupChatAgents = activeGroupChatAgents;
          this.connectedBots.push(groupChat);
        }
        localStorage.setItem("connectedBots", JSON.stringify(this.connectedBots));
        this.toasterService.info("Agent: " + oldAgentFullName + " added agent: " + newAgentFullName + " to chat");
        this.addNotificationToActiveConversations("Agent: " + oldAgentFullName + " added agent: " + newAgentFullName + " to chat", chatId, 'add');
      };

      this._hubConnection.off("onAgentAdded");
      this._hubConnection.on("onAgentAdded", onAgentAddedHandler);

      //on Group Chat Agent Left Handler
      let onGroupChatAgentLeftHandler = (chatId, disconnectedAgentFullName, disconnectedAgentEmailId) => {
        const leftChat = this.connectedBots.find(x => x.ChatId == chatId);
        if (leftChat != null) {
          this.toasterService.warn("Agent: " + disconnectedAgentFullName + " left the chat with Bot user: " + leftChat.BotUserName + " connected to Bot: " + leftChat.BotName);
          this.connectedBots.splice(this.connectedBots.indexOf(leftChat), 1);
          leftChat.GroupChatAgents.agentFullName.splice(leftChat.GroupChatAgents.agentFullName.indexOf(disconnectedAgentFullName), 1);
          leftChat.GroupChatAgents.agentEmailId.splice(leftChat.GroupChatAgents.agentEmailId.indexOf(disconnectedAgentEmailId.toLowerCase()), 1);
          if (leftChat.GroupChatAgents.agentFullName.length == 1 && leftChat.GroupChatAgents.agentFullName.indexOf(this.loggedInAgentFullName) >= 0) {
            leftChat.isGroupChat = false;
            if (this.activeConversationId == chatId)
              this.activeChatIsGroupChat = false;
          }
          this.connectedBots.push(leftChat);
          localStorage.setItem("connectedBots", JSON.stringify(this.connectedBots));
          this.addNotificationToActiveConversations("Agent: " + disconnectedAgentFullName + " left the chat", chatId, 'remove');
        }
        else {
          this.toasterService.warn("Agent: " + disconnectedAgentFullName + " left the chat");
        }
      };

      this._hubConnection.off("onGroupChatAgentLeft");
      this._hubConnection.on("onGroupChatAgentLeft", onGroupChatAgentLeftHandler);

      //on Group Chat Agent Diconnected Handler
      let onGroupChatAgentDisconnectedHandler = (chatId, disconnectedAgentFullName, disconnectedAgentEmailId) => {
        const disconnectedChat = this.connectedBots.find(x => x.ChatId == chatId);
        if (disconnectedChat != null) {
          this.toasterService.warn("Agent: " + disconnectedAgentFullName + " disconnected from the chat with Bot user: " + disconnectedChat.BotUserName + " connected to Bot: " + disconnectedChat.BotName);
          this.connectedBots.splice(this.connectedBots.indexOf(disconnectedChat), 1);
          disconnectedChat.GroupChatAgents.agentFullName.splice(disconnectedChat.GroupChatAgents.agentFullName.indexOf(disconnectedAgentFullName), 1);
          disconnectedChat.GroupChatAgents.agentEmailId.splice(disconnectedChat.GroupChatAgents.agentEmailId.indexOf(disconnectedAgentEmailId.toLowerCase()), 1);
          if (disconnectedChat.GroupChatAgents.agentFullName.length == 1 && disconnectedChat.GroupChatAgents.agentFullName.indexOf(this.loggedInAgentFullName) >= 0) {
            disconnectedChat.isGroupChat = false;
            if (this.activeConversationId == chatId)
              this.activeChatIsGroupChat = false;
          }
          this.connectedBots.push(disconnectedChat);
          localStorage.setItem("connectedBots", JSON.stringify(this.connectedBots));
          this.addNotificationToActiveConversations("Agent: " + disconnectedAgentFullName + " disconnected from the chat", chatId, 'remove');
        }
        else {
          this.toasterService.warn("Agent: " + disconnectedAgentFullName + " disconnected from the chat");
        }

      };

      this._hubConnection.off("onGroupChatAgentDisconnected");
      this._hubConnection.on("onGroupChatAgentDisconnected", onGroupChatAgentDisconnectedHandler);


      //on Agent Added to Group chat handler
      let onGroupChatAgentReconnectedHandler = (agentFullName: string, agentEmailId: string, chatId) => {
        this.connectedBots = JSON.parse(localStorage.getItem("connectedBots"))
        const groupChat = this.connectedBots.find(x => x.ChatId == chatId);
        const reconnectedAgent = groupChat.GroupChatAgents.agentEmailId.find(x => x.toLowerCase() == agentEmailId.toLowerCase())
        if (groupChat != null && reconnectedAgent == null) {
          this.connectedBots.splice(this.connectedBots.indexOf(groupChat), 1);
          groupChat.IsGroupChat = true;
          groupChat.GroupChatAgents.agentFullName.push(agentFullName);
          groupChat.GroupChatAgents.agentEmailId.push(agentEmailId.toLowerCase());
          if (this.activeConversationId == chatId) {
            this.activeChatIsGroupChat = true;
            this.activeGroupChatAgents = groupChat.GroupChatAgents;
          }
          this.connectedBots.push(groupChat);
          localStorage.setItem("connectedBots", JSON.stringify(this.connectedBots));
          this.addNotificationToActiveConversations("Agent: " + agentFullName + " reconnected to chat", chatId, 'add');
          this.toasterService.info("Agent: " + agentFullName + " reconnected to chat");
        }
      };

      this._hubConnection.off("onGroupChatAgentReconnected");
      this._hubConnection.on("onGroupChatAgentReconnected", onGroupChatAgentReconnectedHandler);

      //on Agent Ended Chat Handler
      let onAgentEndedChatHandler = (chatId, disconnectedAgentFullName) => {
        const endConversation = this.conversations.filter(x => x.ChatId == chatId);
        if (endConversation) {
          this.conversations = this.conversations.filter(activity =>
            !endConversation.includes(activity)
          );
          localStorage.setItem("conversations", JSON.stringify(this.conversations));
        }
        const endChat = this.connectedBots.find(x => x.ChatId == chatId);
        if (endChat != null) {
          this.toasterService.warn("Agent: " + disconnectedAgentFullName + " ended the chat with Bot user: " + endChat.BotUserName + " connected to Bot: " + endChat.BotName);
          this.connectedBots.splice(this.connectedBots.indexOf(endChat), 1);
          this.hilRequest = false;
          localStorage.setItem("connectedBots", JSON.stringify(this.connectedBots));
          this.addNotificationToActiveConversations("Agent: " + disconnectedAgentFullName + " ended the chat", chatId, 'remove');
        }
        else {
          this.toasterService.warn("Agent: " + disconnectedAgentFullName + " ended the chat");
        }

      }
      this._hubConnection.off("onAgentEndedChat");
      this._hubConnection.on("onAgentEndedChat", onAgentEndedChatHandler);


      //on Agent Ended Chat Handler
      let onGroupChatLeftSuccessfullyHandler = (chatId) => {
        const endConversation = this.conversations.filter(x => x.ChatId == chatId);
        if (endConversation) {
          this.conversations = this.conversations.filter(activity =>
            !endConversation.includes(activity)
          );
          localStorage.setItem("conversations", JSON.stringify(this.conversations));
        }
        const leftChat = this.connectedBots.find(x => x.ChatId == chatId);
        if (leftChat != null) {
          this.connectedBots.splice(this.connectedBots.indexOf(leftChat), 1);
          this.hilRequest = false;
          localStorage.setItem("connectedBots", JSON.stringify(this.connectedBots));
        }
      }
      this._hubConnection.off("onGroupChatLeftSuccessfully");
      this._hubConnection.on("onGroupChatLeftSuccessfully", onGroupChatLeftSuccessfullyHandler);

      //notify typing status
      let onTypingStatusChangedHandler = (chatId, agentFullName, typingStatus, sender) => {

        var typStatus = { ChatId: chatId, UserFullName: agentFullName, TypingStatus: typingStatus, Sender: sender, DateTime: new Date() };
        const userName = localStorage.getItem("userFullName");

        //add user details to active typing
        if (typingStatus && agentFullName.toLowerCase() != userName.toLowerCase()) {
          const activeTyping = this.activeTypings.find(x => (x.ChatId == typStatus.ChatId
            && x.TypingStatus == true
            && x.UserFullName == typStatus.UserFullName));

          if (activeTyping != undefined || activeTyping != null) {
            this.activeTypings.splice(this.activeTypings.indexOf(activeTyping), 1);
          }
          this.activeTypings.push(typStatus);
        }
        else//remove user details to active typing
        {
          const stoppedTyping = this.activeTypings.find(x => (x.ChatId == typStatus.ChatId && x.UserFullName == typStatus.UserFullName));
          if (stoppedTyping != undefined || stoppedTyping != null) {
            this.activeTypings.splice(this.activeTypings.indexOf(stoppedTyping), 1);
          }
        }
        this.activeTypingsByActiveConversationId = this.activeTypings.filter(x => (x.ChatId == this.activeConversationId));

        //construct active typing user notification
        var activeTypingUserNames = new Array<string>();
        for (var i = 0; i < this.activeTypingsByActiveConversationId.length; i++) {
          activeTypingUserNames.push(this.activeTypingsByActiveConversationId[i].UserFullName);
        }
        if (activeTypingUserNames.length <= 0) {
          this.activeTypingNotificationMessage = null;
        } else if (activeTypingUserNames.length == 1) {
          this.activeTypingNotificationMessage = activeTypingUserNames[0] + " is typing ";
        } else {
          this.activeTypingNotificationMessage = activeTypingUserNames.join(", ") + " are typing ";
        }
      }
      this._hubConnection.off("onTypingStatusChanged");
      this._hubConnection.on("onTypingStatusChanged", onTypingStatusChangedHandler);


      this._hubConnection.onclose(() => {
        if (this.connectedBots.length > 0)
          this.toasterService.warn("Connection closed, re-establishing connection..");
        this.connectedStatusService.sendAgentConnectedStatus(false);
        if (localStorage.getItem('userEmailId') && localStorage.getItem('userEmailId') != '') {
          setTimeout(() => {
            this.service.CreateHubConnection(true);
            this.initialiseConversationTab();
          }, 3000);
        }
      }
      );
    }
    else {
      localStorage.clear();
      this.connectedBots = []; 
      this.openWarning('connectionClosed');
    }
  }

  closeHubConnection() {
    if (this._hubConnection) {
      this._hubConnection
        .stop()
        .then(() => {
          this.connectedStatus = false;
        })
        .catch(err => this.toasterService.error("Error while establishing connection"));
    }
  }

  openWarning(value: string) {
    let dialogRef = this.dialogWarning.open(WarningPopupComponent, {
      height: '27%',
      width: '35%',
      autoFocus: false,
      data: value
    });
    dialogRef.afterClosed().subscribe(result => {

    })
  }
  isFirstMessageChat(chatId: string): boolean {
    const isFirst = localStorage.getItem(chatId) === null;
    if (isFirst) {
      localStorage.setItem(chatId, 'false');
    }
    return isFirst;
  }

  public onNavigationFromNotifications(): void {
    if (localStorage.getItem("navigatedChatId")) {
      var navigatedChatId = localStorage.getItem("navigatedChatId");
      const navigatedBot = JSON.parse(localStorage.getItem("connectedBots")).find(x => x.ChatId == navigatedChatId);
      if (navigatedBot) {
        this.SetSelectedChat(document.getElementById(navigatedChatId), navigatedBot);
      }
      localStorage.removeItem("navigatedChatId");
    }
  }

  public sendNotification(activity: IConversation): void {
    this.notificationService.sendHilConversationNotification(activity);
  }

  public clearAllNotifications(): void {
    this.notificationService.clearAllNotifications();
  }

  public specialCharacterCheck(text): boolean {
    let count = 0;
    for (let i = 0; i < this.message.length; i++) {
      if (this.message[i].match(/[^A-Za-z0-9 ]/)) {
        count++;
        if (count === 4) {
          return this.specialcharacter = true;
        }
      }
      else {
        count = 0;
      }
    }
    return this.specialcharacter = false;
  }

  public checkForHTML(text): boolean {
    var elem = document.createElement('div')
    elem.innerHTML = text;
    this.htmlElements = !!elem.childElementCount;
    return this.htmlElements;
  }

  public sendMessage(): void {
    if (this.message.trim().length > 0) {
      const userName = localStorage.getItem("userFullName");
      const activity: IConversation = {
        ChatId: this.activeConversationId,
        Message: this.message,
        Type: 'send',
        DateTime: new Date(),
        Sender: userName,
        BotId: this.activeBotId,
        HasAttachment: false,
        IsImage: '',
        IsAssociatedBotAgent: this.isAssociatedBotAgent,
        AssociatedBotConfigId: this.associatedBotId
      };

      this.specialCharacterCheck(this.message);
      this.checkForHTML(this.message);

      if (this.specialcharacter == false && this.htmlElements == false) {
        if (this._hubConnection) {

          if (this.isFirstMessageChat(this.activeConversationId)) {
            this.FirstMessage = true;
          } else {
            this.FirstMessage = false;
          }          
          this._hubConnection
            .invoke('Send', activity, true,this.FirstMessage)
            .then(() => {
              this.conversations.push(activity);
              this.activeConversations = this.conversations.filter(x => x.ChatId == this.activeConversationId);
              this.message = '';
              document.getElementById("message").blur();
              this.notifyTypingStatusOffSourceSendButton = true;
              this.notifyTypingStatusOff(null);
              localStorage.setItem("conversations", JSON.stringify(this.conversations));
              this.scrollToBottom();
            })

            .catch(err => {
              //TODO with status code
              if (err.message === "Failed to invoke 'Send' because user is unauthorized") {
                this.getRefreshToken();
              }
            })
        }
        else {
          this.toasterService.error("Error Occured. Invalid Input");
        }
      }
      else {
        this.toasterService.error("Error Occured.Invalid input or special characters are not allowed.");
      }
    }
  }

  //custom message
  public sendMessageFileUpload(message: any): void {
    const userName = localStorage.getItem("userFullName");
    this.click = false;
    const activity: IConversation = {
      ChatId: this.activeConversationId,
      Message: message,
      Type: 'send',
      DateTime: new Date(),
      Sender: userName,
      BotId: this.activeBotId,
      HasAttachment: false,
      IsImage: '',
      IsAssociatedBotAgent: this.isAssociatedBotAgent,
      AssociatedBotConfigId: this.associatedBotId
    };

    if (this._hubConnection) {
      this._hubConnection
        .invoke('Send', activity, true, this.FirstMessage)
        .then(() => {
          this.conversations.push(activity);
          this.activeConversations = this.conversations.filter(x => x.ChatId == this.activeConversationId);
          this.message = '';
          document.getElementById("message").blur();
          this.notifyTypingStatusOffSourceSendButton = true;
          this.notifyTypingStatusOff(null);
          localStorage.setItem("conversations", JSON.stringify(this.conversations));
          this.scrollToBottom();
        })

        .catch(err => {
          //TODO with status code
          if (err.message === "Failed to invoke 'Send' because user is unauthorized") {
            this.getRefreshToken();
          }
        })
    }
  }

  getRefreshToken() {
    this.tokenService.getRefreshToken()
      .subscribe(
        res => {
          let objToken = res;
          localStorage.setItem('accessToken', objToken.token);
          localStorage.setItem('refreshToken', objToken.refreshToken);
          this.sendMessage();
        },
        (error) => {
        }
      );
  }
  applyBadgeOnConnectedBot(element: any, cssClass: any): void {
    if (element) {
      element.add(cssClass);
    }
  }
  removeBadgeOnConnectedBot(element: any, cssClass: any): void {
    if (element) {
      element.remove(cssClass);
    }
  }

  removeSelectionFromConnectedBots(): void {
    var connectedBotList = document.getElementsByClassName('active-chat');
    for (var i = 0; i < connectedBotList.length; i++) {
      connectedBotList[i].classList.remove('active-chat');
    }
  }

  scrollToBottom(): void {
    this.scrollerHt = document.getElementById("msgWindow") ? document.getElementById("msgWindow").scrollHeight : 0;
  }

  setActiveConnectedBot(bot: any): void {
    this.activeBotUserName = bot.BotUserName;
    this.activeBotUserId = bot.BotUserId;
    this.activeBotName = bot.BotName;
    this.activeBotConfigId = bot.BotConfigId;
    this.activeBotHandOffComment = bot.HandOffInfo;
    this.activeChatbotHistory = bot.ChatHistory;
    this.activeConversationId = bot.ChatId;
    this.activeConversations = this.conversations.filter(x => x.ChatId == this.activeConversationId);
    this.activePrimaryAgent = bot.IsPrimaryAgent;
    this.activeChatIsGroupChat = bot.IsGroupChat;
    this.activeGroupChatAgents = bot.GroupChatAgents;
    this.activeBotId = bot.BotId;
    this.message = '';
    this.activeTypingNotificationMessage = null;
    this.IsValidChatManagerRole = bot.IsChatManagerRole;
    this.hasAssociatedBot = bot.HasAssociatedBot;
    this.associatedBotId = bot.AssociatedBotConfigId;
    this.associatedBotName = bot.AssociatedBotName;
  }

  showSelectedChat() {
    this.hilRequest = true;
  }

  SetSelectedChat(event, bot): void {
    //set bot as currently active one in the connected bot list
    this.setActiveConnectedBot(bot);
    const countGrantMsg = this.conversations.filter((obj) => obj.Message === "*#grant" && obj.ChatId == this.activeConversationId).length;
    const countUrlMsg = this.conversations.filter((obj) => obj.Message.includes('/file-attachments/') && obj.ChatId == this.activeConversationId).length;
    if (countGrantMsg != 0 && countUrlMsg != 0) {
      if (countGrantMsg == countUrlMsg) {
        this.click = false;
      }
    }
    if (countGrantMsg != 0 || countUrlMsg != 0) {
      if (countGrantMsg == countUrlMsg) {
        this.click = true;
      }
    }
    if (countGrantMsg != 0 || countUrlMsg != 0) {
      if (countGrantMsg != countUrlMsg) {
        this.click = false;
      }
    }
    if (countGrantMsg == 0 && countUrlMsg == 0) {
      this.click = true;
    }
    //reload the active chat css on connected bot list
    if (event)
      this.removeBadgeOnConnectedBot((event.classList ? event.classList : event.target.classList), 'new-chat-notification');
    this.removeSelectionFromConnectedBots();
    if (event)
      this.applyBadgeOnConnectedBot((event.classList ? event.classList : event.target.classList), 'active-chat');
    this.showSelectedChat();
  }

  CloseObsoleteMapping(chatId: string): void {
    this._hubConnection
      .invoke('CloseObsoleteMappingAsync', chatId, "Agent", "")
      .then(() => {
      })
  }

  EndSelectedChat(): void {

    const myChat = this.connectedBots.find(x => x.ChatId == this.activeConversationId);
    const con = this.conversations.find(y => y.ChatId == this.activeConversationId)
    let stringChatInfo = JSON.stringify(myChat);

    const jsonChatInfo = JSON.parse(stringChatInfo);
    let history = jsonChatInfo["ChatHistory"];

    let conhistory = this.activeConversations;

    conhistory.forEach(item => {
      history.push({ 'Message': item.Message, 'Sender': item.Sender, 'type': item.Type == 'send' ? 'Agent' : 'User', 'DateTime': item.DateTime });
    });


    this._hubConnection
      .invoke('EndChatByAgentAsync', this.activeConversationId, localStorage.getItem("userFullName"), localStorage.getItem("terminationReason"), conhistory, this.isAssociatedBotAgent, this.associatedBotId)
      .then(() => {
        this.activeConversations = [];
        const endChat = this.connectedBots.find(x => x.ChatId == this.activeConversationId);
        if (endChat != null) {
          this.connectedBots.splice(this.connectedBots.indexOf(endChat), 1);
          this.hilRequest = false;
          localStorage.setItem("connectedBots", JSON.stringify(this.connectedBots));
          localStorage.setItem(this.activeConversationId, "true");
          //this.toasterService.info();
          history = [];
        }
      })
  }

  LeaveSelectedChat(): void {
    this._hubConnection
      .invoke('LeaveChatByAgentAsync', this.activeConversationId, localStorage.getItem("userFullName"))
      .then(() => {
        this.activeConversations = [];
        const leaveChat = this.connectedBots.find(x => x.ChatId == this.activeConversationId);
        if (leaveChat != null) {
          this.connectedBots.splice(this.connectedBots.indexOf(leaveChat), 1);
          this.hilRequest = false;
          localStorage.setItem("connectedBots", JSON.stringify(this.connectedBots));
        }
      })
  }

  notifyTypingStatusOn(e): void {
    if (this._hubConnection && this.connectedBots.length > 0 && this.activeConversationId != "" && this.message != "") {
      this._hubConnection
        .invoke('NotifyTypingStatusAsync', this.activeConversationId, localStorage.getItem("userFullName"), true, "Agent")
        .then(() => {
        })
    }
    //validating <img src=0 onerror=alert(1)> Cross Site Scripting tags.
    const input = e.target as HTMLInputElement;
    const textboxvalue = input.value;
    if (textboxvalue.includes('onerror')) {
      this.messageboxvalid = false;
    }
    else {
      this.messageboxvalid = true;
    }
  }

  notifyTypingStatusOff(event): void {
    if (this._hubConnection && this.connectedBots.length > 0 && this.activeConversationId != "" && (!(document.getElementById("message") == document.activeElement) || !(this.isCCenterWindowFocused))) {
      this._hubConnection
        .invoke('NotifyTypingStatusAsync', this.activeConversationId, localStorage.getItem("userFullName"), false, "Agent")
        .then(() => {
          if (this.notifyTypingStatusOffSourceSendButton) {
            document.getElementById("message").focus();
            this.notifyTypingStatusOffSourceSendButton = false;
          }
        })
    }
  }

  AgentLogOut(): void {
    this._hubConnection
      .stop()
      .then(() => {
        //this.toasterService.warn("Agent logged-out");
      })
      .catch(err => this.toasterService.error("Error while establishing connection"));
  }

  showComment(activeBotHandOffComment: IHandOffComments[]) {
    let dialogRef = this.dialogComment.open(HandoffCommentComponent, {
      height: '60%',
      width: '60%',
      autoFocus: false,
      data: JSON.stringify(activeBotHandOffComment)
    });
    dialogRef.afterClosed().subscribe(result => {

    })
  }

  showConfirmationPopUp(chatStatus: string) {
    localStorage.removeItem('endChat');
    localStorage.removeItem('leaveChat');
    localStorage.removeItem('terminationReason');
    let data = {
      chatStatus: chatStatus,
      botConfigId: this.activeBotConfigId,
    }
    let dialogRef = this.dialogWarning.open(WarningPopupComponent, {
      height: '27%',
      width: '35%',
      autoFocus: false,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (localStorage.getItem('endChat') == 'true')
        this.EndSelectedChat();
      else if (localStorage.getItem('leaveChat') == 'true')
        this.LeaveSelectedChat();
    })
  }

  showBotChatHistory(activeChatbotHistory: IChatHistory[]) {
    let dialogRef = this.dialogComment.open(BotHistoryComponent, {
      height: '60%',
      width: '60%',
      autoFocus: false,
      data: {
        chatHistory: JSON.stringify(activeChatbotHistory),
        isAssociatedBotAgent: this.isAssociatedBotAgent
      }
    });
    dialogRef.afterClosed().subscribe(result => {

    })
  }

  addAgentSeniorAgent() {
    const botInfoForAddAgent =
    {
      BotId: this.activeBotId,
      BotConfigId: this.activeBotConfigId,
      BotUserId: this.activeBotUserId,
      ConversationId: this.activeConversationId,
      BotUserName: this.activeBotUserName,
      ChatHistory: this.activeChatbotHistory,
      HandOffInfo: this.activeBotHandOffComment,
      Domain: "",
      BotName: this.activeBotName,
      NewAgentId: "",
      AddedByAgentId: this.agentLoginId,
      Conversations: this.activeConversations,
      GroupChatAgents: this.activeGroupChatAgents,
      IsValidChatManagerRole: this.IsValidChatManagerRole,
      HasAssociatedBot: this.hasAssociatedBot,
      AssociatedBotId: this.associatedBotId,
      AssociatedBotName: this.associatedBotName
    }


    let dialogRef = this.dialogComment.open(AddNewAgentComponent, {
      height: '63%',
      width: '60%',
      autoFocus: false,
      data: JSON.stringify(botInfoForAddAgent)
    });
    dialogRef.afterClosed().subscribe(result => {
    })
  }

  showParticipantList() {
    let dialogRef = this.dialogComment.open(GroupChatParticipantsComponent, {
      height: '33%',
      width: '30%',
      autoFocus: false,
      data: JSON.stringify(this.activeGroupChatAgents)
    });
    dialogRef.afterClosed().subscribe(result => {
    })
  }

  showBotUserDetails() {
    clearTimeout(this.tooltipDisplay);
    this.showBotUserDetailsTootTip = true;
    this.tooltipDisplay = setTimeout(() => {
      this.showBotUserDetailsTootTip = false;
    }, 4000);
  }

  endChat() {
    this.showConfirmationPopUp('endChat');
  }

  leaveChat() {
    this.showConfirmationPopUp('leaveChat');
  }

  addNotificationToActiveConversations(Notification: string, ChatId: string, Type: string) {
    const notificationActivity: IConversation = {
      ChatId: ChatId,
      Message: Notification,
      Type: Type == 'add' ? 'addNotification' : Type == 'remove' ? 'removeNotification' : '',
      DateTime: new Date(),
      Sender: 'System',
      BotId: '',
      HasAttachment: false,
      IsImage: '',
      IsAssociatedBotAgent: this.isAssociatedBotAgent,
      AssociatedBotConfigId: this.associatedBotId
    };
    this.conversations.push(notificationActivity);
    this.activeConversations = this.conversations.filter(x => x.ChatId == this.activeConversationId);
    localStorage.setItem("conversations", JSON.stringify(this.conversations));
  }
  onClick(event) {
    var target = event.target || event.srcElement || event.currentTarget;
    var idAttr = event.currentTarget;
    var value = idAttr.id;
    this.imageURL = value;
    //isImage
    const array = ['.jpg', '.png'];
    const substring = this.imageURL;

    const match = array.find(element => {
      if (element.includes(substring)) {
        return true;
      }
    });
    if (match !== undefined) {
      // array contains substring match
      this.isImage = 'block';
    }
    if (this.imageURL.includes('jpg')) {
      this.isImage = 'block';
    }
  }
  OpenOfficeFiles(data) {
    let encodedUrl = encodeURIComponent(data);
    if (data.includes('pdf')) {
      this.hrefLink = data;
      window.open(data, '_blank');
    } else {
      this.hrefLink = "https://view.officeapps.live.com/op/view.aspx?src=" + encodedUrl + "&wdOrigin=BROWSELINK";
      window.open(this.hrefLink, '_blank');
    }
  }
}
